export const DRAWER_WIDTH = 300;

// Max width for page content in the admin and portal UIs (MUI Container breakpoint key).
// Matches the Plugin Marketplace layout; chat views are intentionally left full-width.
export const CONTENT_MAX_WIDTH = "xl";
